var _rect, _rect2, _rect3, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 40,
    viewBox: "0 0 140 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 40,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 2622.23,
    transform: "translate(-40 -1193.91)",
    fill: "#141414"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 449.225,
    transform: "translate(-40 -66.9062)",
    fill: "#141414"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.598 1.8219H39.64V3.26242H129.598C134.246 3.26242 138.027 6.99364 138.027 11.5798V28.8538C138.027 33.4398 134.246 37.171 129.598 37.171H111.517V35.638L107.336 37.7836L111.517 39.9291V38.6115H129.598C135.051 38.6115 139.487 34.2342 139.487 28.8538V11.5798C139.487 6.19928 135.051 1.8219 129.598 1.8219Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1140_2032",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.396851H104.294V38.6116H0V0.396851Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1140_2032)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45997 28.8536V11.5796C1.45997 6.99344 5.24158 3.26223 9.88965 3.26223H31.6631V4.68757L35.8446 2.54209L31.6631 0.396484V1.82171H9.88965C4.43649 1.82171 0 6.19908 0 11.5796V28.8536C0 34.234 4.43649 38.6113 9.88965 38.6113H104.294V37.1707H9.88965C5.24158 37.1707 1.45997 33.4395 1.45997 28.8536Z",
    fill: "#F2F2F2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.756 15.6505V18.5688H24.5856V22.0576H14.756V27.4775H10.2193V12.1177H26.5204V15.6505H14.756Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3446 27.4774V15.3212H32.7257V17.5813C33.7486 15.8698 35.6834 15.0359 37.8851 15.0359V18.6344C35.2609 18.6344 33.3706 19.622 32.7257 21.6187V27.4774H28.3446Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0671 19.995L50.2726 19.951C49.8056 18.5249 48.6269 17.8445 46.7589 17.8445C44.8686 17.8445 43.5564 18.5249 43.0671 19.995ZM47.2925 24.9101C49.2496 24.9101 50.4282 24.4493 51.6514 23.5278L53.8753 25.8316C52.1184 27.3675 49.8501 27.9821 47.0479 27.9821C41.8217 27.9821 38.775 25.4807 38.775 21.3993C38.775 17.318 41.7774 14.8165 46.7143 14.8165C51.1621 14.8165 54.3201 17.0108 54.3201 21.3115C54.3201 21.7943 54.2978 22.0795 54.2088 22.3209H42.956C43.3117 24.164 44.8018 24.9101 47.2925 24.9101Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1695 19.995L67.3749 19.951C66.9079 18.5249 65.7292 17.8445 63.8612 17.8445C61.9709 17.8445 60.6588 18.5249 60.1695 19.995ZM64.3949 24.9101C66.352 24.9101 67.5306 24.4493 68.7538 23.5278L70.9776 25.8316C69.2207 27.3675 66.9524 27.9821 64.1503 27.9821C58.9241 27.9821 55.8774 25.4807 55.8774 21.3993C55.8774 17.318 58.8797 14.8165 63.8166 14.8165C68.2645 14.8165 71.4224 17.0108 71.4224 21.3115C71.4224 21.7943 71.4001 22.0795 71.3112 22.3209H60.0583C60.4141 24.164 61.9041 24.9101 64.3949 24.9101Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1169 19.9073V22.8695C79.0954 24.0983 80.4519 24.6029 81.9419 24.6029C84.2548 24.6029 85.5447 23.418 85.5447 21.3994C85.5447 19.3587 84.2548 18.1738 81.9419 18.1738C80.4519 18.1738 79.0954 18.6785 78.1169 19.9073ZM78.0946 25.6782V31.8659H73.7136V15.3213H78.0946V17.0986C79.1844 15.7381 80.9189 14.8605 83.1652 14.8605C87.0348 14.8605 89.7033 17.3619 89.7033 21.3994C89.7033 25.4147 87.0348 27.9163 83.1652 27.9163C80.9189 27.9163 79.1844 27.0605 78.0946 25.6782Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1140_2032",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 40
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.9291H139.487V0.396851H0V39.9291Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1140_2032)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1281 27.4772H96.5313V11.2397H92.1281V27.4772Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.564 23.6594C108.719 22.4964 107.162 22.1893 105.894 22.1893C104.649 22.1893 102.981 22.4964 102.981 23.7911C102.981 25.0856 104.649 25.3928 105.894 25.3928C107.162 25.3928 108.719 25.0856 109.564 23.9007V23.6594ZM113.811 20.6532V25.1734C113.811 26.0511 113.967 26.7752 114.345 27.4774H109.897C109.653 27.1044 109.475 26.6435 109.475 26.2266V26.2046C108.541 27.1702 106.828 27.9162 104.649 27.9162C102.047 27.9162 98.7332 26.9068 98.7332 23.7911C98.7332 20.6752 102.047 19.6658 104.649 19.6658C106.828 19.6658 108.541 20.412 109.475 21.3993V20.6094C109.475 18.7663 108.096 17.8885 105.405 17.8885C103.937 17.8885 102.492 18.0859 100.979 18.8321L99.9786 16.0892C101.646 15.2993 104.182 14.8385 106.317 14.8385C111.009 14.8385 113.811 16.9012 113.811 20.6532Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.091 15.3212L122.463 31.8659H118.037L120.839 26.7971L114.746 15.3212H119.26L123.019 22.8694L126.644 15.3212H131.091Z",
    fill: "#F2F2F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeplay);
export default __webpack_public_path__ + "static/media/freeplay.89fdbcb08f5086623aa3651b7e279651.svg";
export { ForwardRef as ReactComponent };